import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-skeleton',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      aria-busy="true"
      class="animate-pulse"
      role="status"
      [attr.aria-label]="ariaLabel()"
      [ngClass]="containerClass()">
      @switch (variant()) {
        @case ('card') {
          <div class="rounded-lg border border-border p-6 space-y-4">
            <div class="h-6 bg-secondary/20 rounded w-1/3"></div>
            <div class="space-y-2">
              <div class="h-4 bg-secondary/20 rounded w-full"></div>
              <div class="h-4 bg-secondary/20 rounded w-5/6"></div>
              <div class="h-4 bg-secondary/20 rounded w-4/6"></div>
            </div>
          </div>
        }
        @case ('chart') {
          <div class="rounded-lg border border-border p-6">
            <div class="h-6 bg-secondary/20 rounded w-1/4 mb-4"></div>
            <div class="h-[var(--area-chart-height)] bg-secondary/20 rounded"></div>
          </div>
        }
        @case ('table') {
          <div class="rounded-lg border border-border p-6 space-y-3">
            <div class="h-10 bg-secondary/20 rounded"></div>
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <div class="h-8 bg-secondary/20 rounded"></div>
            }
          </div>
        }
        @default {
          <div class="h-4 bg-secondary/20 rounded w-full"></div>
        }
      }
      <span class="sr-only">Loading...</span>
    </div>
  `,
  host: {
    'animate.leave': 'content-leave',
  },
})
export class LoadingSkeletonComponent {
  readonly variant = input<'card' | 'chart' | 'table' | 'text'>('text');
  readonly containerClass = input<string>('');
  readonly ariaLabel = input<string>('Loading content');
}
